import React, { memo } from "react";
import PropTypes from "prop-types";
import { getIn } from "formik";
import FormControl from "@mui/material/FormControl";
import { styled } from "@mui/material/styles";
import { CustomCheckbox } from "./CustomCheckbox";
import { InfoTitle } from "../../../components/InfoTitle";
import { ContexualHelp, ErrorMessage } from "../../Notifications";
import { areEqualFieldProps, omitProps } from "../utils";

const FormControlRoot = styled("div")(({ theme }) => ({
  margin: "12px 0 24px",
  width: "100%",
  display: "flex",
  "& > div:last-child": {
    marginTop: 10
  }
}));

const InfoTitleWrapper = styled("div")({});

export const CheckboxBase = ({
  infoTitle,
  label = "",
  value = true,
  field,
  form: { errors, touched },
  classes: extendedClasses,
  contextualHelpText,
  contextualHelpProps = {},
  ...rest
}) => {
  const errorMessage = getIn(errors, field.name);
  const hasError = errorMessage && getIn(touched, field.name);

  return (
    <FormControl classes={{ root: FormControlRoot }} className="formControlContainer">
      <ContexualHelp title={contextualHelpText} {...contextualHelpProps}>
        <CustomCheckbox
          {...field}
          {...omitProps(rest)}
          classes={extendedClasses}
          label={label}
          value={value}
          checked={field.value === value}
        />
      </ContexualHelp>
      {hasError && <ErrorMessage error={errorMessage} />}
      {infoTitle && <InfoTitle classes={{ wrapper: InfoTitleWrapper }} title={infoTitle} />}
    </FormControl>
  );
};

CheckboxBase.propTypes = {
  infoTitle: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
  field: PropTypes.object.isRequired,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object
  }).isRequired,
  classes: PropTypes.object,
  contextualHelpText: PropTypes.string,
  contextualHelpProps: PropTypes.object
};

export const Checkbox = memo(CheckboxBase, areEqualFieldProps);
